import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ListagemObrasComponent } from '../listagem-obras/listagem-obras.component';
import { environment } from 'src/environments/environment';
import { Router, RouterModule } from '@angular/router';
import { HomeService } from '../home-service/home.service';
import { BlocoSolicitarNovaObraComponent } from '../bloco-solicitar-nova-obra/bloco-solicitar-nova-obra.component';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

@Component({
  selector: 'app-bloco-obras-responsabilidade',
  standalone: true,
  templateUrl: './bloco-obras-responsabilidade.component.html',
  styleUrls: ['./bloco-obras-responsabilidade.component.scss'],
  imports: [CommonModule, MatIconModule, BlocoSolicitarNovaObraComponent, RouterModule],
})
export class BlocoObrasResponsabilidadeComponent implements OnInit {
  obrasSobMinhaResponsabilidade: any[] = [];
  obrasNaoVistas: any[] = [];
  obrasEquipe: any[] = [];
  listagemAberta: boolean = false;
  obrasParaListagem: any[] = [];
  myWorks: number;
  teamWorks: number;
  notSeen: number;
  myWorksUpdatedLast7Days: number;
  teamWorksUpdatedLast7Days: number;
  notSeenAddedToday: number;
  level: string;
  loading = true;

  constructor(private readonly router: Router, private readonly _homeService: HomeService, private readonly authService: AuthService) {
        this.level = this.authService.level;
  }

  ngOnInit() {
    this.obrasSobMinhaResponsabilidade = [
      { id: 1, nome: 'Obra 1', ...{} },
      { id: 2, nome: 'Obra 2', ...{} },
    ];
    this.obrasNaoVistas = [{ id: 3, nome: 'Obra 3', ...{} }];
    this.obrasEquipe = [
      { id: 4, nome: 'Obra 4', ...{} },
      { id: 5, nome: 'Obra 5', ...{} },
    ];

    this.getQuantityOfWorks();
  }

  getLinkObras() {
      this.router.navigate(['/home-obras']);
  }

  abrirListagem(tipo: 'minha' | 'naoVistas' | 'equipe') {
    if (tipo === 'minha') {
      this.obrasParaListagem = this.obrasSobMinhaResponsabilidade;
    } else if (tipo === 'naoVistas') {
      this.obrasParaListagem = this.obrasNaoVistas;
    } else {
      this.obrasParaListagem = this.obrasEquipe;
    }
    this.listagemAberta = true;
  }

  fecharListagem() {
    this.listagemAberta = false;
    this.obrasParaListagem = [];
  }

  getQuantityOfWorks(): void {
    this._homeService.listQuantityWorks().subscribe(
      (response) => {
        const data = response.data;
        this.myWorks = data.myWorks;
        this.teamWorks = data.teamWorks;
        this.notSeen = data.notSeen;
        this.myWorksUpdatedLast7Days = data.myWorksUpdatedLast7Days;
        this.teamWorksUpdatedLast7Days = data.teamWorksUpdatedLast7Days;
        this.notSeenAddedToday = data.notSeenAddedToday;
        this.loading = false;
      },
      (error) => {
        console.error('Erro ao obter quantidade de obras:', error);
        this.loading = false;
      }
    );
  }

}
